<template>
  <v-dialog light v-model="show" max-width="800px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark class="my-2 mx-0" v-on="on">
        {{ title }}
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="py-2 pt-3">
        <span class="headline">{{ formTitle }}</span>
        <v-chip v-show="id" small class="ml-auto">{{ id }}</v-chip>
      </v-card-title>
      <v-card-text>
        <v-form>
          <slot name="form"></slot>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'BaseAdminDialog',
    props: {
      id: String,
      value: {
        type: Boolean,
        required: true,
        default: false
      },
      title: {
        type: String,
        required: false,
        default: 'Item'
      },
      formTitle: String,
      save: Function,
      close: Function
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>